import { ELogoutActionTypes, TLogoutLoading } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const logoutRequest: () => TLogoutLoading = actionGenerator<ELogoutActionTypes.Loading>(
  ELogoutActionTypes.Loading,
);
